export * from "./tabs";



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/components/index.ts